export default "__VITE_ASSET__BkjQqnSM__"